import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumOrderStatus implements BaseEnumType {
  private static allValues: EnumOrderStatus[] = []; // make sure this is top-most
  
  public static none = new EnumOrderStatus(0, "None", "enum_order_status_none");
  public static open = new EnumOrderStatus(1, "Open", "enum_order_status_open");
  public static complete = new EnumOrderStatus(2, "Complete", "enum_order_status_complete");
  public static historic = new EnumOrderStatus(3, "Historic", "enum_order_status_historic");
  public static cancelled = new EnumOrderStatus(4, "Cancelled", "enum_order_status_cancelled");
  public static posting = new EnumOrderStatus(5, "Posting", "enum_order_status_posting");
  public static draft = new EnumOrderStatus(6, "Draft", "enum_order_status_draft");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumOrderStatus.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isNone() { return this === EnumOrderStatus.none; }
  public isOpen() { return this === EnumOrderStatus.open; }
  public isComplete() { return this === EnumOrderStatus.complete; }
  public isHistoric() { return this === EnumOrderStatus.historic; }
  public isCancelled() { return this === EnumOrderStatus.cancelled; }
  public isPosting() { return this === EnumOrderStatus.posting; }
  public isDraft() { return this === EnumOrderStatus.draft; }

  public static getValues(): readonly EnumOrderStatus[] {
    return EnumOrderStatus.allValues;
  }

  public static getValuesExcept0(): readonly EnumOrderStatus[] {
    return EnumOrderStatus.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumOrderStatus {
    const found = EnumOrderStatus.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumOrderStatus - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumOrderStatus): EnumOrderStatus {
    const found = name ? EnumOrderStatus.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumOrderStatus - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumOrderStatus>): boolean {
    return this.key === other?.key;
  }
}